import { colors } from '../constants';
const styleOverrides = {
  root: {
    alignItems: 'start',
    '& .Mui-checked': {
      '&, & + .MuiFormControlLabel-label': {
        color: colors.text.active
      }
    },
    '& .Mui-disabled': {
      '&, & + .MuiFormControlLabel-label': {
        color: colors.text.disabled
      }
    }
  },
  label: {
    paddingTop: 11
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiFormControlLabel.js.map